module.exports = __webpack_public_path__ + "img/tr_p_candidates_faq@2x.66be7324.jpg";